import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Inbox, Users } from 'lucide-react';
import { MAIL_API, mailAuth, getMailbox, setMailbox } from './mailUtils';

// Buttons under the Mail title: your own mailbox plus any shared ones an admin granted (AP@, admin@, sales@ …).
export function MailboxSwitch({ onChange }) {
  const [boxes, setBoxes] = useState(null);
  const active = getMailbox();
  useEffect(() => {
    axios.get(`${MAIL_API}/mailboxes`, mailAuth(true)).then(r => {
      setBoxes(r.data.mailboxes);
      // a mailbox that was revoked since last visit falls back to your own
      if (getMailbox() && !r.data.mailboxes.some(b => b.email === getMailbox())) { setMailbox(''); onChange(''); }
    }).catch(() => setBoxes([]));
  }, []);
  if (!boxes || boxes.length < 2) return null;
  const pick = (b) => {
    const next = b.own ? '' : b.email;
    if (next === active) return;
    setMailbox(next);
    onChange(next);
  };
  return (
    <div className="flex items-center gap-1.5 flex-wrap" data-testid="mailbox-switch">
      {boxes.map(b => {
        const on = b.own ? !active : active === b.email;
        return (
          <button key={b.email} type="button" onClick={() => pick(b)} title={b.email}
            className={`px-3 py-1.5 rounded-full text-xs font-bold inline-flex items-center gap-1.5 border transition-colors ${on ? 'bg-slate-900 text-white border-slate-900' : 'bg-white/70 text-slate-700 border-slate-300 hover:bg-white'}`}
            data-testid={`mailbox-btn-${b.label}`} aria-pressed={on}>
            {b.own ? <Inbox className="w-3.5 h-3.5" /> : <Users className="w-3.5 h-3.5" />}
            {b.own ? 'My mail' : `${b.label}@`}
          </button>
        );
      })}
    </div>
  );
}
